import { render, staticRenderFns } from "./SubItemCategoryView.vue?vue&type=template&id=321f589f&scoped=true"
import script from "./SubItemCategoryView.vue?vue&type=script&lang=js"
export * from "./SubItemCategoryView.vue?vue&type=script&lang=js"
import style0 from "./SubItemCategoryView.vue?vue&type=style&index=0&id=321f589f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f589f",
  null
  
)

export default component.exports